import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './update.css';
import { connect } from 'react-redux';
import { ReactComponent as BackArrow } from '../../../assets/images/svgIcons/LeftArrow.svg';
import ApiService from '../../../services/apiService';
import CategoryCardEdit from '../categoryCard/CategoryCardEdit';
import {
  AddToOrder,
  RemoveFromOrder,
  clearOrder,
  downgradeOrderItemQuantity,
  updateOrderItem,
  updateOrderItemQuantity,
  updateOrderItemVoid,
  updateOrderItemRefund,
} from '../../../../Redux/actions/orderEditAction';
import { useDispatch } from 'react-redux';
import { getOrderEditData, getTaxExplicit, getUserName } from '../../../../Redux/selecters';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import UpdateItemCard from './updateItemCard';
import userManagement from '../../../services/userManagement';
import { toast } from 'react-toastify';
import { invokeBroadCastMessage } from '../../../services/signalRService';
import { AddToCart, clearCart, setOrderType } from '../../../../Redux/actions/cartAction';
import DiscountModal from '../cashierbucket/addDiscount';
import CreatableSelect from 'react-select/creatable';
import { RiDeleteBin2Fill } from 'react-icons/ri';

const UpdateOrder = ({ Currency }) => {
  const { state } = useLocation();
  const { allowed } = state || {};

  // Use Redux state for order data
  const orderData = useSelector(getOrderEditData);
  const userName = useSelector(getUserName);
  const taxExplicit = useSelector(getTaxExplicit);

  const [discountModal, setDiscountModalOpen] = useState(false);
  const [TaxModal, setTaxModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [menu, setMenu] = useState([]);
  const [table, setTable] = useState();
  const [taxes, setTax] = useState([]);
  const [areDiscountDisable, setDiscountDisable] = useState(false);
  const [isPaymentAllow, setPaymentAllow] = useState(false);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState([]);
  const [areTaxDisable, setTaxDisable] = useState(false);
  const [loading, setLoading] = useState(false);

  let token = localStorage.getItem('Token');
  let Permission = userManagement?.getUserCrud(token);
  let userRole = userManagement.getUserRole(token);
  let navigate = useNavigate();
  let dispatch = useDispatch();

  useEffect(() => {
    // Set permissions
    const isDiscountDisable = Permission?.includes('Discount.add') && Permission.includes('Discount.query');
    setDiscountDisable(!isDiscountDisable);
    const isTaxDisable = Permission?.includes('Tax.add') && Permission.includes('Tax.query');
    setTaxDisable(!isTaxDisable);
    const isPaymentAllow = Permission?.includes('Payment.add') && Permission.includes('Payment.query');
    setPaymentAllow(!isPaymentAllow);
  }, []);

  useEffect(() => {
    GetCategory();
    GetTax();
    GetTable();
  }, [searchTerm]);

  useEffect(() => {
    if (selectedCategory && !subCategories.length) {
      GetSubCategories(selectedCategory.recordId);
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (allowed) {
      proceed();
    }
  }, [allowed]);

  // Calculation functions - simplified for retail
  const calculateTotalPrice = () => {
    let totalPrice = 0;

    orderData.forEach((item) => {
      if (!item.void && !item.refund && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemPrice =
          parseFloat(item?.selectedVariant?.variantPrice) || parseFloat(item?.itemData?.menuItemPrice) || parseFloat(item?.itemData?.price) || 0;

        totalPrice += itemPrice * item.quantity;
      }
    });

    return totalPrice;
  };

  const calculateTotalDiscount = () => {
    let totalDiscount = 0;
    orderData?.forEach((item) => {
      if (!item.void && !item.refund && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemDiscount = getItemDiscountPrice(item);
        totalDiscount += itemDiscount * item?.quantity;
      }
    });
    return totalDiscount || state?.discount || 0;
  };

  const getItemDiscountPrice = (item) => {
    const discountType = item?.itemData?.discountType;
    const discount = item?.itemData?.menuItemDiscount || item?.itemData?.discount || 0;

    if (discountType === 'Amount') {
      return parseFloat(discount);
    } else if (discountType === 'Percentage') {
      const itemPrice = parseFloat(item?.selectedVariant?.variantPrice || item?.itemData?.menuItemPrice || 0);
      return (itemPrice * parseFloat(discount)) / 100;
    }
    return 0;
  };

  const calculateTotalTax = () => {
    let totalTax = 0;

    orderData?.forEach((item) => {
      if (!item.void && !item.refund && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        const itemTax = calculateItemTax(item);
        totalTax += itemTax * item.quantity;
      }
    });

    return totalTax;
  };

  const calculateItemTax = (item) => {
    const taxRate = parseFloat(item?.itemData?.tax || item?.itemData?.menuItemTax || 0);
    const itemPrice = parseFloat(item.selectedVariant?.variantPrice || item?.itemData?.price || item?.itemData?.menuItemPrice || 0);
    return (taxRate / 100) * itemPrice;
  };

  const calculateSelectedTaxes = () => {
    let totalSelectedTaxes = 0;
    const totalPrice = calculateTotalPrice();

    selectedTaxPercentage?.forEach((tax) => {
      const taxValue = tax.value?.taxPercentage || 0;
      const taxAmount = (totalPrice * taxValue) / 100;
      totalSelectedTaxes += taxAmount;
    });

    return totalSelectedTaxes;
  };

  const calculateTotalPriceWithTaxesAndDiscounts = () => {
    let totalPrice = calculateTotalPrice();
    totalPrice += calculateTotalTax();
    totalPrice -= calculateTotalDiscount();
    totalPrice += calculateSelectedTaxes();
    return Math.max(0, totalPrice);
  };

  // Event handlers using Redux actions
  const handleQuantityChange = (item, index) => {
    dispatch(updateOrderItemQuantity(index, item?.itemData?.id || item?.itemData?.itemId));
  };

  const handleQuantityChangeDec = (item, index) => {
    if (item.quantity > 1) {
      dispatch(downgradeOrderItemQuantity(index, item?.itemData?.id || item?.itemData?.itemId));
    }
  };

  const handleVoidCheckbox = (item, index) => {
    const newVoidStatus = !item.void;
    dispatch(updateOrderItemVoid(index, item?.itemData?.id || item?.itemData?.itemId, newVoidStatus));

    // If unvoiding, also clear refund status
    if (!newVoidStatus && item.refund) {
      dispatch(updateOrderItemRefund(index, item?.itemData?.id || item?.itemData?.itemId, false));
    }
  };

  const handleRefund = (item, index) => {
    // Can only refund if item is voided
    if (item.void) {
      const newRefundStatus = !item.refund;
      dispatch(updateOrderItemRefund(index, item?.itemData?.id || item?.itemData?.itemId, newRefundStatus));
    } else {
      toast.warning('Item must be voided before refunding');
    }
  };

  const handleItemRemove = (item, index) => {
    dispatch(RemoveFromOrder(item, index));
  };

  const handlePageback = () => {
    dispatch(clearOrder());
    setSelectedCategory(null);
    setMenu([]);
    navigate('/Cashier/SaleHistory');
  };

  const closeDiscountModal = () => {
    setDiscountModalOpen(false);
  };

  const openDiscountModal = () => {
    if (orderData?.length > 0) {
      setDiscountModalOpen(true);
    } else {
      toast.warning('No items to apply discount');
    }
  };

  const closeTaxModal = () => {
    setTaxModalOpen(false);
  };

  const openTaxModal = () => {
    setTaxModalOpen(true);
  };

  const handleSelectedTax = (selectedItem) => {
    setSelectedTaxPercentage(selectedItem || []);
  };

  // API functions
  const proceed = async () => {
    try {
      // First update the order data (items, quantities, void/refund status)
      await UpdateOrderData();

      // Clear existing cart data
      dispatch(clearCart());

      // Transform order data to cart format
      const transformedCartData = orderData.map((orderItem, index) => {
        // Extract the matched variant data
        const matchedVariant = orderItem?.itemData?.orderItemsMeta?.find((metaItem) => metaItem.metaItemIndex === orderItem.itemData.itemIndex);

        // Create selectedVariant object in cart format
        let selectedVariant = null;
        if (matchedVariant) {
          selectedVariant = {
            recordId: matchedVariant.metaItemId,
            itemDescription: matchedVariant.metaItemName,
            salePrice: matchedVariant.variantPrice || orderItem.itemData.menuItemPrice,
            vat: matchedVariant.tax || '0.00',
            taxRate: matchedVariant.taxRate || 0,
          };
        }

        // Calculate item price (matching CashierBucket calculateItemPrice logic)
        const itemPrice = selectedVariant?.salePrice || orderItem.itemData.menuItemPrice || orderItem.itemData.price || 0;

        // Transform to cart format that matches CashierBucket expectations
        const cartItem = {
          // Main item data (matching CashierBucket structure)
          item: {
            recordId: orderItem.itemData.id || orderItem.itemData.itemId,
            itemName: orderItem.itemData.menuItemName || orderItem.itemData.name,
            salePrice: itemPrice,
            taxRate: orderItem.itemData.tax || orderItem.itemData.menuItemTax || 0,
            vat: selectedVariant?.vat || '0.00',
          },

          // Selected variant (matching CashierBucket variant structure)
          selectedVariant: selectedVariant,

          // Basic cart properties
          name: orderItem.itemData.menuItemName || orderItem.itemData.name,
          price: itemPrice,
          quantity: orderItem.quantity,
          specialInstructions: orderItem.specialInstructions || orderItem.itemData.kitchenInstructions || '',

          // Discount information (if any)
          discount: orderItem.itemData.menuItemDiscount || orderItem.itemData.discount || 0,
          discountType: orderItem.itemData.discountType || 'Amount',
          discountId: orderItem.itemData.discountId || 0,

          // Promotion information (if any)
          promotionId: orderItem.itemData.promotionId || 0,
          selectedPromotionDetails: orderItem.itemData.selectedPromotionDetails || null,

          // Status flags
          void: orderItem.void || orderItem.itemData.voidItem || false,
          refund: orderItem.refund || orderItem.itemData.refunded || false,

          // Original order item data (for reference)
          itemData: {
            ...orderItem.itemData,
            // Ensure these fields are properly set for CashierBucket calculations
            voidItem: orderItem.void || orderItem.itemData.voidItem || false,
            refunded: orderItem.refund || orderItem.itemData.refunded || false,
          },

          // Add-ons and modifiers (empty for retail system)
          selectedAdOn: [],
          selectedModifier: [],

          // Index for tracking
          index: index,
        };

        return cartItem;
      });

      // Add each transformed item to cart
      transformedCartData.forEach((cartItem) => {
        dispatch(AddToCart(cartItem));
      });

      // Set order type if available
      if (state?.orderType !== undefined) {
        const orderTypeMap = {
          0: 'Dine-In',
          1: 'Take-Away',
          2: 'Delivery',
          7: 'Pick-up',
        };
        const orderTypeName = orderTypeMap[state.orderType] || 'Take-Away';
        dispatch(setOrderType(orderTypeName));
      }

      // Navigate to cashier with proper state for PAYMENT PROCESSING ONLY
      const itemNumber = state?.id?.replace(/^ORD-/i, '');
      navigate('/cashier/home', {
        state: {
          state: true,
          Update: itemNumber, // This flags it as existing order payment
          paymentStatus: state?.paymentStatus,
          orderDiscount: state?.discount || 0,
          allowed: allowed,
          // Additional data for payment processing
          originalOrderData: {
            orderId: itemNumber,
            customerId: state?.customerId,
            customerName: state?.customerName,
            tableId: state?.tableId,
            orderType: state?.orderType,
            totalAmount: calculateTotalPriceWithTaxesAndDiscounts(),
            calculatedTax: calculateTotalTax() + calculateSelectedTaxes(),
            totalDiscount: calculateTotalDiscount(),
            isPaymentOnly: true, // Flag to indicate this is payment only, not order creation
          },
        },
      });
    } catch (error) {
      console.error('Error in proceed function:', error);
      toast.error('Failed to proceed to payment. Please try again.');
    }
  };

  const UpdateOrderData = async () => {
    try {
      setLoading(true);
      const itemNidumber1 = state?.id?.replace(/^ORD-/i, '');

      const dataReq = {
        id: parseInt(itemNidumber1),
        orderItems: orderData?.map((item, index) => ({
          itemId: parseInt(item.itemData.id || item?.itemData?.itemId),
          quantity: parseInt(item.quantity),
          kitchenInstructions: item.specialInstructions || '',
          voidItem: item?.void || item?.itemData?.voidItem || false,
          refunded: item?.refund || item?.itemData?.refunded || false,
          itemIndex: index,
        })),
        orderItemsMeta: orderData.flatMap(mapDynamicMetaData),
        loggedInUserId: userManagement.getUserId(token) || 'Guest',
      };

      const datareq1 = {
        id: parseInt(itemNidumber1),
        orderAmount: calculateTotalPriceWithTaxesAndDiscounts(),
        totalDiscount: calculateTotalDiscount(),
        amountRefunded: 0,
        calculatedTax: calculateTotalTax() + calculateSelectedTaxes(),
        discountId: orderData[0]?.itemData?.discountId || 0,
        promotionId: orderData[0]?.itemData?.promotionId || 0,
      };

      const apiService = new ApiService();
      const res = await apiService.put('UPDATE_ORDER_META', dataReq);
      const res1 = await apiService.put('UPDATE_ORDER', datareq1);

      if (res && res1) {
        toast.success('Order Updated Successfully');
        invokeBroadCastMessage(`Order Updated. OrderNo#${itemNidumber1.toString()}`);
      } else {
        toast.error('Failed to update order. Please try again.');
      }
    } catch (error) {
      console.error('Error updating order:', error);
      toast.error('Failed to update order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const mapDynamicMetaData = (item) => {
    const result = [];

    // Simplified for retail - mainly handling variants
    if (item?.selectedVariant) {
      if (Array.isArray(item.selectedVariant)) {
        result.push(
          ...item.selectedVariant.map((variant) => ({
            metaItemId: parseInt(variant?.metaItemId),
            type: parseInt(variant?.metaType),
            menuItemId: parseInt(item?.itemData?.id || item?.itemData?.itemId),
            metaItemIndex: parseInt(item?.index),
          }))
        );
      } else {
        result.push({
          metaItemId: parseInt(item?.selectedVariant?.metaItemId),
          type: parseInt(item?.selectedVariant?.metaType),
          menuItemId: parseInt(item?.itemData?.id || item?.itemData?.itemId),
          metaItemIndex: parseInt(item?.index),
        });
      }
    }

    return result;
  };
  // Fix 1: Update GetCategory function
  const GetCategory = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let parameters = searchTerm ? `?Name=${encodeURIComponent(searchTerm)}` : '';
      const res = await apiService.getApiParamater('GET_CATEGORY_MASTER', parameters);

      console.log('Categories API Response:', res); // Debug log

      if (res?.data?.statusCode === 200) {
        // Fix the property mapping and active check
        const filteredCategories = res?.data?.result?.filter((item) => item?.active === 1) || [];

        // Map the properties to match what your code expects
        const mappedCategories = filteredCategories.map((category) => ({
          ...category,
          id: category.recordId, // Map recordId to id
          name: category.catName, // Map catName to name
        }));

        console.log('Mapped Categories:', mappedCategories); // Debug log
        setCategories(mappedCategories);
      } else {
        console.warn('No categories found or API error:', res);
        setCategories([]);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Failed to load categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  // Fix 2: Update GetSubCategories function (assuming similar structure)
  const GetSubCategories = async (categoryId) => {
    try {
      if (!categoryId) {
        setSubCategories([]);
        return;
      }

      const apiService = new ApiService();
      let parameters = `?CategoryId=${categoryId}`;
      const res = await apiService.getApiParamater('GET_SUB_CATEGORY_MASTER', parameters);

      console.log('SubCategories API Response:', res); // Debug log

      if (res?.data?.statusCode === 200) {
        // Fix the active check and property mapping
        const activeSubCategories = res?.data?.result?.filter((item) => item?.active === 1) || [];

        // Map properties if needed (adjust based on actual subcategory API response)
        const mappedSubCategories = activeSubCategories.map((subCat) => ({
          ...subCat,
          id: subCat.recordId || subCat.id,
          name: subCat.catName || subCat.name || subCat.subCatName,
        }));

        setSubCategories(mappedSubCategories);
      } else {
        setSubCategories([]);
      }
    } catch (error) {
      console.error('Error fetching sub-categories:', error);
      toast.error('Failed to load subcategories');
      setSubCategories([]);
    }
  };

  // Fix 3: Update handleMenu function
  const handleMenu = async (subCategory = null) => {
    try {
      if (!selectedCategory) return;

      setLoading(true);
      setSelectedSubCategory(subCategory?.name || null);

      const apiService = new ApiService();
      // Use the correct ID property
      let parameters = subCategory
        ? `?SubCategoryId=${subCategory.id || subCategory.recordId}`
        : `?CategoryId=${selectedCategory.id || selectedCategory.recordId}`;

      const res = await apiService.getApiParamater('GET_MENU', parameters);

      console.log('Menu API Response:', res); // Debug log

      if (res?.data?.statusCode === 200) {
        // Fix the active check for menu items
        const activeMenuItems = res?.data?.result?.filter((item) => item?.active === 1) || [];

        // Map menu item properties if needed
        const mappedMenuItems = activeMenuItems.map((menuItem) => ({
          ...menuItem,
          id: menuItem.recordId || menuItem.id,
          name: menuItem.itemName || menuItem.name || menuItem.menuItemName,
        }));

        setMenu(mappedMenuItems);
      } else {
        setMenu([]);
        if (subCategory) {
          toast.info(`No items found in ${subCategory.name}`);
        }
      }
    } catch (error) {
      console.error('Error fetching menu:', error);
      toast.error('Failed to load menu items');
      setMenu([]);
    } finally {
      setLoading(false);
    }
  };

  // 3. ENHANCED EVENT HANDLERS
  const handleMenuClick = async (selectedCategory) => {
    if (!selectedCategory) return;

    setSelectedCategory(selectedCategory);
    setSelectedSubCategory(null);
    setMenu([]);

    // Load subcategories and initial menu items concurrently
    try {
      await Promise.all([
        GetSubCategories(selectedCategory.id),
        handleMenu(), // Load main category items
      ]);
    } catch (error) {
      console.error('Error loading category data:', error);
    }
  };

  const handleBack = () => {
    setSelectedCategory(null);
    setSelectedSubCategory(null);
    setSubCategories([]);
    setMenu([]);
    // Optionally refresh categories
    GetCategory();
  };

  const handleSubCategoryClick = (subCategory) => {
    if (selectedSubCategory === subCategory?.name) {
      // If clicking the same subcategory, show all category items
      setSelectedSubCategory(null);
      handleMenu();
    } else {
      // Load specific subcategory items
      handleMenu(subCategory);
    }
  };

  const GetTable = async () => {
    try {
      const apiService = new ApiService();
      let parameters = `?Id=${state?.tableId}`;
      const res = await apiService.getApiParamater('GET_TABLE', parameters);
      setTable(res?.data?.result?.[0]);
    } catch (error) {
      console.error('Error fetching table:', error);
    }
  };

  const GetTax = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_TAX');
      const filteredTax = res?.data?.result?.filter((tax) => tax?.vat === false);
      setTax(filteredTax);
    } catch (error) {
      console.error('Error fetching taxes:', error);
    }
  };

  // Helper functions
  const mapOrderType = (orderType) => {
    const typeMap = {
      0: 'DineIn',
      1: 'Takeout',
      2: 'Delivery',
      3: 'OnlineOrder',
      4: 'DriveThru',
      5: 'Catering',
      6: 'RoomService',
      7: 'Pickup',
      8: 'CurbsidePickup',
    };
    return typeMap[orderType] || 'Unknown Order Type';
  };

  const mapOrderStatus = (orderStatus) => {
    const statusMap = {
      0: 'New Order',
      1: 'Accepted',
      2: 'Preparing',
      3: 'Ready For Delivery',
      4: 'Ready For Pick up',
      5: 'Out For Delivery',
      6: 'Delivered',
      7: 'Cancelled',
      8: 'On-Hold',
    };
    return statusMap[orderStatus] || 'Unknown Order Status';
  };

  const itemNidumber = state?.id;
  const itemNidumber1 = state?.id?.replace(/^ORD-/i, '');

  return (
    <>
      <div className="m-5">
        {/* Enhanced Order Header */}
        <div
          className="HeadBG"
          style={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
            border: '2px solid #E9ECFF',
            boxShadow: '0 8px 32px rgba(110, 81, 153, 0.15)',
          }}
        >
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Table No
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {!table?.name ? 'No Table' : table?.name}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Order No
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {state?.id}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              KOT
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              KOT-{itemNidumber}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Type
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {mapOrderType(state?.orderType)}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Cashier
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {userName}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Customer
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {state?.customerName || 'Walk-in'}
            </div>
          </div>
          <div className="">
            <label className="form-label" style={{ color: '#6E5199', fontWeight: '600', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Status
            </label>
            <div
              className="brdrbt"
              style={{
                background: '#6E5199',
                color: '#fff',
                fontWeight: '600',
                boxShadow: '0 4px 12px rgba(110, 81, 153, 0.3)',
              }}
            >
              {mapOrderStatus(state?.orderStatus)}
            </div>
          </div>
        </div>

        <div className="row pt-5 p-3">
          {/* Enhanced Order Items Table */}
          <div
            className="col-lg-7 tablebG"
            style={{
              borderRadius: '16px',
              border: '2px solid #E9ECFF',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                // background: 'linear-gradient(135deg, #6E5199 0%, #8B7CB6 100%)',
                padding: '16px 20px',
                color: '#000',
              }}
            >
              <h6 style={{ margin: 0, fontWeight: '600', fontSize: '16px' }}>🛒 Order Items ({orderData.length})</h6>
            </div>

            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <table className="table mb-0">
                <thead className="thead-clr" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th style={{ padding: '16px', fontWeight: '700', fontSize: '13px', color: '#6E5199' }}>Item</th>
                    <th style={{ padding: '16px', fontWeight: '700', fontSize: '13px', color: '#6E5199' }}>Variant</th>
                    <th style={{ padding: '16px', fontWeight: '700', fontSize: '13px', color: '#6E5199', textAlign: 'center' }}>Quantity</th>
                    <th style={{ padding: '16px', fontWeight: '700', fontSize: '13px', color: '#6E5199 ', textAlign: 'right' }}>Rate</th>
                    {userRole !== 'Waiter' && (
                      <th style={{ padding: '16px', fontWeight: '700', fontSize: '13px', color: '#6E5199', textAlign: 'center' }}>Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {orderData?.map((item, index) => {
                    const matchedVariant = item?.itemData.orderItemsMeta?.find((metaItem) => metaItem.metaItemIndex === item.itemData.itemIndex);
                    const itemPrice =
                      parseFloat(matchedVariant?.variantPrice) ||
                      parseFloat(item?.selectedVariant?.variantPrice) ||
                      parseFloat(item?.itemData?.menuItemPrice) ||
                      parseFloat(item?.itemData?.price) ||
                      0;

                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: item.void ? 'rgba(255, 193, 7, 0.1)' : item.refund ? 'rgba(220, 53, 69, 0.1)' : 'transparent',
                          borderLeft: item.void ? '4px solid #ffc107' : item.refund ? '4px solid #dc3545' : 'none',
                        }}
                      >
                        <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#212529', marginBottom: '4px' }}>
                              {item?.itemData?.menuItemName || item?.itemData?.name}
                            </div>
                            <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                              {item.void && (
                                <span
                                  style={{
                                    backgroundColor: '#ffc107',
                                    color: '#212529',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  VOID
                                </span>
                              )}
                              {item.refund && (
                                <span
                                  style={{
                                    backgroundColor: '#dc3545',
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  REFUND
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                          {matchedVariant && <span style={{ fontSize: '13px', color: '#6c757d', fontStyle: 'italic' }}>{matchedVariant.metaItemName}</span>}
                        </td>
                        <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                          <div className="d-flex align-items-center justify-content-center">
                            <button
                              onClick={() => handleQuantityChangeDec(item, index)}
                              disabled={item.quantity === 1}
                              style={{
                                width: '32px',
                                height: '32px',
                                border: '2px solid #6E5199',
                                borderRadius: '8px',
                                backgroundColor: item.quantity === 1 ? '#f8f9fa' : '#fff',
                                color: item.quantity === 1 ? '#adb5bd' : '#6E5199',
                                cursor: item.quantity === 1 ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: '700',
                                transition: 'all 0.2s ease',
                              }}
                            >
                              -
                            </button>
                            <span
                              style={{
                                margin: '0 16px',
                                fontWeight: '700',
                                fontSize: '16px',
                                minWidth: '24px',
                                textAlign: 'center',
                                color: '#6E5199',
                              }}
                            >
                              {item.quantity}
                            </span>
                            <button
                              onClick={() => handleQuantityChange(item, index)}
                              style={{
                                width: '32px',
                                height: '32px',
                                border: '2px solid #6E5199',
                                borderRadius: '8px',
                                backgroundColor: '#fff',
                                color: '#6E5199',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: '700',
                                transition: 'all 0.2s ease',
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#6E5199';
                                e.target.style.color = '#fff';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.color = '#6E5199';
                              }}
                            >
                              +
                            </button>
                          </div>
                        </td>
                        <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'right' }}>
                          <div style={{ fontWeight: '700', fontSize: '15px', color: '#27ae60' }}>
                            {Currency.currency.name} {itemPrice.toFixed(2)}
                          </div>
                        </td>
                        {userRole !== 'Waiter' && (
                          <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                            <div className="d-flex gap-2 justify-content-center">
                              {state?.paymentStatus === 2 ? (
                                <>
                                  <button
                                    onClick={() => handleVoidCheckbox(item, index)}
                                    style={{
                                      padding: '6px 12px',
                                      borderRadius: '8px',
                                      border: 'none',
                                      backgroundColor: item.void ? '#dc3545' : '#ffc107',
                                      color: '#fff',
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s ease',
                                      textTransform: 'uppercase',
                                    }}
                                  >
                                    {item.void ? 'Unvoid' : 'Void'}
                                  </button>
                                  {item.void && (
                                    <button
                                      onClick={() => handleRefund(item, index)}
                                      style={{
                                        padding: '6px 12px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        backgroundColor: item.refund ? '#28a745' : '#dc3545',
                                        color: '#fff',
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        textTransform: 'uppercase',
                                      }}
                                    >
                                      {item.refund ? 'Unrefund' : 'Refund'}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <button
                                  onClick={() => handleItemRemove(item, index)}
                                  style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    border: '2px solid #dc3545',
                                    backgroundColor: '#fff',
                                    color: '#dc3545',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#dc3545';
                                    e.target.style.color = '#fff';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.color = '#dc3545';
                                  }}
                                >
                                  <RiDeleteBin2Fill size={16} />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Enhanced Categories/Menu Section */}
          <div className={`col-lg-5 ${state?.paymentStatus === 2 ? 'disabled-div' : ''}`}>
            <div
              style={{
                background: '#fff',
                borderRadius: '16px',
                border: '2px solid #E9ECFF',
                padding: '20px',
                height: '450px',
                overflow: 'hidden',
              }}
            >
              {selectedCategory ? (
                <div className="h-100 d-flex flex-column">
                  <div className="d-flex align-items-center gap-3 mb-4">
                    <button
                      className="btn"
                      onClick={handleBack}
                      style={{
                        background: 'linear-gradient(135deg, #6E5199 0%, #8B7CB6 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontSize: '14px',
                        fontWeight: '600',
                      }}
                    >
                      <BackArrow style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                      Back
                    </button>
                    <div
                      style={{
                        background: 'linear-gradient(135deg, #E9ECFF 0%, #f8f9ff 100%)',
                        color: '#6E5199',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        fontWeight: '700',
                        fontSize: '16px',
                        flex: 1,
                        textAlign: 'center',
                      }}
                    >
                      {selectedCategory?.name}
                    </div>
                  </div>

                  {subCategories?.length > 0 && (
                    <div className="mb-4">
                      <div className="d-flex gap-2 flex-wrap">
                        {subCategories?.map((cat) => (
                          <button
                            key={cat.id} // Use the mapped id
                            className={`btn ${selectedSubCategory === cat?.name ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleMenu(cat)} // Fixed: was handlemenu(cat)
                            style={{
                              borderRadius: '8px',
                              fontSize: '12px',
                              fontWeight: '600',
                              padding: '8px 16px',
                              backgroundColor: selectedSubCategory === cat?.name ? '#6E5199' : 'transparent',
                              borderColor: '#6E5199',
                              color: selectedSubCategory === cat?.name ? '#fff' : '#6E5199',
                            }}
                          >
                            {cat.name}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div className="row g-3">
                      {menu?.map((item) => (
                        <div key={item.id} className="col-6">
                          <UpdateItemCard val={item} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="h-100 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 style={{ color: '#6E5199', fontWeight: '700', margin: 0 }}>📂 Categories</h5>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search Categories"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        maxWidth: '200px',
                        borderRadius: '10px',
                        border: '2px solid #E9ECFF',
                      }}
                    />
                  </div>
                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div className="row g-3">
                      {categories?.map((item) => (
                        <div key={item.id} className="col-6">
                          {' '}
                          {/* Use mapped id */}
                          <CategoryCardEdit val={item} handleMenuClick={handleMenuClick} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Enhanced Order Summary */}
          <div className="row p-3 mt-4">
            <div
              className="col-lg-7 tablebG"
              style={{
                borderRadius: '16px',
                border: '2px solid #E9ECFF',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  background: 'linear-gradient(135deg, #6E5199 0%, #8B7CB6 100%)',
                  padding: '16px 20px',
                  color: '#fff',
                }}
              >
                <h6 style={{ margin: 0, fontWeight: '600', fontSize: '16px' }}>💰 Order Summary</h6>
              </div>

              <div style={{ padding: '20px', background: '#fff' }}>
                <div className="d-flex justify-content-between py-2">
                  <div className="char" style={{ color: '#6E5199', fontWeight: '600' }}>
                    Subtotal
                  </div>
                  <div className="char" style={{ color: '#27ae60', fontWeight: '700' }}>
                    {Currency.currency.name} {calculateTotalPrice()?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
                <div className="d-flex justify-content-between py-2">
                  <div className="char" style={{ color: '#6E5199', fontWeight: '600' }}>
                    Tax
                  </div>
                  <div className="char" style={{ color: '#f39c12', fontWeight: '700' }}>
                    {Currency.currency.name} {calculateTotalTax().toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
                <div className="d-flex justify-content-between py-2">
                  <div className="char" style={{ color: '#6E5199', fontWeight: '600' }}>
                    Discount
                  </div>
                  <div className="char" style={{ color: '#e74c3c', fontWeight: '700' }}>
                    -{Currency.currency.name} {calculateTotalDiscount().toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
                {selectedTaxPercentage?.map((tax, index) => (
                  <div key={index} className="d-flex justify-content-between py-2">
                    <div style={{ color: '#6E5199', fontWeight: '600', fontSize: '14px' }}>
                      {tax?.label} ({tax?.value?.taxPercentage || 0}%)
                    </div>
                    <div style={{ color: '#f39c12', fontWeight: '700', fontSize: '14px' }}>
                      {Currency.currency.name} {((calculateTotalPrice() * (tax?.value?.taxPercentage || 0)) / 100).toFixed(2)}
                    </div>
                  </div>
                ))}
                <hr style={{ margin: '16px 0', borderColor: '#E9ECFF', borderWidth: '2px' }} />
                <div className="d-flex justify-content-between py-2">
                  <div style={{ color: '#6E5199', fontWeight: '700', fontSize: '18px' }}>Total Amount</div>
                  <div style={{ color: '#27ae60', fontWeight: '700', fontSize: '20px' }}>
                    {Currency.currency.name}{' '}
                    {calculateTotalPriceWithTaxesAndDiscounts().toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>
            </div>

            {/* Enhanced Action Buttons */}
            <div className="col-lg-5">
              <div style={{ padding: '20px' }}>
                <div className="row g-3 mb-3">
                  {/* {!isPaymentAllow && ( */}
                  <div className="col-6">
                    <button
                      onClick={proceed}
                      disabled={loading}
                      style={{
                        width: '100%',
                        background: loading ? '#95a5a6' : 'linear-gradient(135deg, #6e5199 0%, #6e5199 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '14px',
                        fontSize: '14px',
                        fontWeight: '700',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(39, 174, 96, 0.3)',
                      }}
                    >
                      {loading ? '⏳ Processing...' : '💳 Proceed'}
                    </button>
                  </div>
                  {/* )} */}
                  <div className="col-6">
                    <button
                      style={{
                        width: '100%',
                        background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '14px',
                        fontSize: '14px',
                        fontWeight: '700',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(52, 152, 219, 0.3)',
                      }}
                    >
                      🖨️ Print Bill
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      onClick={UpdateOrderData}
                      disabled={loading}
                      style={{
                        width: '100%',
                        background: loading ? '#95a5a6' : 'linear-gradient(135deg, #6e5199 0%, #6e5199 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '14px',
                        fontSize: '14px',
                        fontWeight: '700',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(243, 156, 18, 0.3)',
                      }}
                    >
                      {loading ? '⏳ Updating...' : '✏️ Update Order'}
                    </button>
                  </div>
                </div>

                <div className="row g-3">
                  {!areDiscountDisable && (
                    <div className="col-6">
                      <button
                        onClick={openDiscountModal}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '12px',
                          padding: '12px',
                          fontSize: '13px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 12px rgba(231, 76, 60, 0.3)',
                        }}
                      >
                        🏷️ Add Discount
                      </button>
                    </div>
                  )}
                  {!areTaxDisable && (
                    <div className="col-6">
                      <button
                        onClick={openTaxModal}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '12px',
                          padding: '12px',
                          fontSize: '13px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          boxShadow: '0 4px 12px rgba(155, 89, 182, 0.3)',
                        }}
                      >
                        📊 Add Tax
                      </button>
                    </div>
                  )}
                  <div className="col-6">
                    <button
                      onClick={handlePageback}
                      style={{
                        width: '100%',
                        background: 'linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(149, 165, 166, 0.3)',
                      }}
                    >
                      ⬅️ Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Modals */}
      <Modal size="lg" show={discountModal} onHide={closeDiscountModal}>
        <DiscountModal closeDiscountModal={closeDiscountModal} />
      </Modal>

      <Modal size="md" show={TaxModal} onHide={closeTaxModal}>
        <Modal.Header
          closeButton
          style={{
            background: 'linear-gradient(135deg, #6E5199 0%, #8B7CB6 100%)',
            color: '#fff',
            borderBottom: 'none',
          }}
        >
          <Modal.Title style={{ fontWeight: '600' }}>📊 Add Tax</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          <CreatableSelect
            isMulti
            options={taxes?.map((tax) => ({ value: tax, label: tax?.name }))}
            value={selectedTaxPercentage}
            onChange={handleSelectedTax}
            className=""
            isClearable
            styles={{
              control: (provided, state) => ({
                ...provided,
                borderColor: state.isFocused ? '#6E5199' : '#dee2e6',
                borderRadius: '10px',
                minHeight: '45px',
                border: '2px solid',
                boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(110, 81, 153, 0.25)' : null,
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused ? '#6E5199' : '#fff',
                color: state.isFocused ? '#fff' : '#333',
                fontWeight: '500',
              }),
            }}
          />
        </Modal.Body>
        <Modal.Footer style={{ padding: '20px 30px', borderTop: '1px solid #f1f3f4' }}>
          <button
            onClick={closeTaxModal}
            style={{
              background: 'linear-gradient(135deg, #6E5199 0%, #8B7CB6 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Save Changes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(UpdateOrder);
